import { Link } from 'react-router-dom';

interface ServiceBlockProps {
  id: string;
  icon: string;
  title: string;
  tagline: string;
  description: string;
  features: string[];
  image: string;
  imageAlt: string;
  reverse?: boolean;
  ctaText?: string;
}

export default function ServiceBlock({
  id,
  icon,
  title,
  tagline,
  description,
  features,
  image,
  imageAlt,
  reverse = false,
  ctaText = 'Book a Consultation',
}: ServiceBlockProps) {
  return (
    <article
      id={id}
      className={`flex flex-col lg:flex-row gap-12 xl:gap-20 items-center ${reverse ? 'lg:flex-row-reverse' : ''}`}
    >
      {/* Image */}
      <div className="w-full lg:w-5/12 flex-shrink-0">
        <div className="relative rounded-2xl overflow-hidden h-[440px] w-full">
          <img
            src={image}
            alt={imageAlt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
          <div className="absolute top-5 left-5">
            <div className="w-12 h-12 bg-[#C9A961] rounded-xl flex items-center justify-center">
              <i className={`${icon} text-xl text-white`}></i>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="w-full lg:w-7/12">
        <p className="text-[#C9A961] text-xs font-bold tracking-widest uppercase mb-3">{tagline}</p>
        <h2 className="text-4xl font-bold text-gray-900 mb-5 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
          {title}
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed mb-7">
          {description}
        </p>
        <ul className="space-y-3 mb-8">
          {features.map((feat, i) => (
            <li key={i} className="flex items-start text-gray-700">
              <span className="w-5 h-5 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                <i className="ri-check-double-line text-[#C9A961] text-base"></i>
              </span>
              <span className="text-sm leading-relaxed">{feat}</span>
            </li>
          ))}
        </ul>
        <div className="flex flex-wrap gap-4">
          <a
            href="tel:866-857-8487"
            className="inline-flex items-center bg-[#C9A961] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B89851] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            <i className="ri-phone-line mr-2"></i>
            {ctaText}
          </a>
          <Link
            to="/locations"
            className="inline-flex items-center border border-gray-300 text-gray-700 px-8 py-4 rounded-full font-semibold hover:border-[#C9A961] hover:text-[#C9A961] transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            View Service Areas
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}
